import React from 'react';
import './CardGroupLeftPanel.css';
import MagicButton from 'components/MagicButton/MagicButton';
import { Points } from 'components/Points/Points';
import { AssetUrls } from 'config/assets';
import { AvatarWithFlag } from 'components/AvatarWithFlag';

interface CardGroupLeftPanelProps {
  userName: string;
  userAvatar: string;
  userCountry?: string;
  userPoints: number;
  imageUrl?: string;
  onRemoveAll?: () => void;
  onSend?: () => void;
  onReset?: () => void;
  isRemoved?: boolean;
}

const CardGroupLeftPanel: React.FC<CardGroupLeftPanelProps> = ({
  userName,
  userAvatar,
  userCountry,
  userPoints,
  imageUrl = AssetUrls.sampleCardCrops.chromium,
  onRemoveAll,
  onSend,
  onReset,
  isRemoved = false,
}) => {

  return (
    <div className="card-group-left">
      <div className="artist-image">
        <div className="artist-top-info">
          <div className="user-info">
            <AvatarWithFlag
              avatarUrl={userAvatar}
              username={userName}
              countryCode={userCountry}
              size={32}
            />
            <p className="user-name">
              <strong>{userName}</strong>
            </p>
          </div>
          <Points points={userPoints} type="small" />
        </div>
        <div className="artist-bottom-info">
          {/* Show Remove All / Reset button when we have the handler */}
          {onRemoveAll && (
            <MagicButton
              label={isRemoved ? "Reset" : "Remove All"}
              icon={
                isRemoved ? (
                  <img
                    src="https://trademagic-assets.s3.us-west-1.amazonaws.com/assets/icons/ViewCard/reset.svg"
                    alt="Reset"
                    style={{ width: 16, height: 16 }}
                  />
                ) : (
                  <img
                    src="https://trademagic-assets.s3.us-west-1.amazonaws.com/assets/icons/ViewCard/want-no.svg"
                    alt="Remove"
                    style={{ width: 16, height: 16 }}
                  />
                )
              }
              color="dark-grey"
              fullWidth={true}
              onPress={isRemoved ? (onReset || (() => {})) : onRemoveAll}
            />
          )}
          <MagicButton
            label="Send"
            icon={
              <img
                src={AssetUrls.icons.misc.sendPackage}
                alt="Send Icon"
                style={{ width: 20, height: 20 }}
              />
            }
            color="purple"
            fullWidth={true}
            onPress={onSend || onRemoveAll || (() => {})}
          />
        </div>
      </div>
    </div>
  );
};

export default CardGroupLeftPanel;
